import { TextField, TextFieldProps, useRecordContext } from 'react-admin';

interface HtmlFieldProps extends TextFieldProps {
  source: string,
  showButton: boolean,
}

const HtmlField = ({ showButton, ...props }: HtmlFieldProps) => {
  // const { source } = props;
  const record = useRecordContext();

  if (undefined === record) {
    return <></>;
  }
  // console.log(record[props]);
  return (
    // <TextField  {...props}></TextField>
    <div style={{ width: '100%', height: '100px', overflow: 'scroll', backgroundColor: 'lightgray', resize: 'vertical' }} dangerouslySetInnerHTML={{ __html: record[props.source] }}></div>
  )
}

HtmlField.defaultProps = {
  showButton: false,
}

export default HtmlField;
